import { BaseDto } from "@models/base/baseDto.model";

/** Un campo del registro de ancho fijo */
export class DetalleTemplateBancoDto {
  public id: number = 0
  public idTemplateBanco?: number | null
  public ordenCampo: number = 0
  /** Debe coincidir con una propiedad de FileDataBankTransferDto, o ser TotalImporte / CuentaRegistro */
  public nombreCampo: string = ""
  public largoCampo: number = 0
  public sinEspacios: boolean = false
  public esNumerico: boolean = false
  public completaConCeros: boolean = false
  /** Los marcados van al pie del archivo, no a los renglones de detalle */
  public esUltimaLinea: boolean = false
  public concatenaEnUltimaLinea: boolean = false
  public valorPorDefecto: string | null = null
  public alineacionIzq: boolean = false
  public alineacionDer: boolean = false
  public cantidadDecimales: number = 0
}

export class TemplateBancoDto extends BaseDto {
  public banco!: BaseDto
  public extensionArchivo: string = ""
  public nombreArchivo: string = ""
  public detallesTemplateBanco: DetalleTemplateBancoDto[] = []
}

export class GuardarTemplateBancoRequest {
  public id: number = 0
  public descripcion: string = ""
  public idBanco?: number | null
  public idTipoTemplateBanco?: number | null
  public nombreArchivo: string = ""
  public extensionArchivo: string = ""
  public campos: DetalleTemplateBancoDto[] = []
}
